<template lang="pug">
	.orders-page
		header.orders-header
			.left-part
				button.btn.btn-primary.new-order(@click="showCreateNewOrder")
					i.fa.fa-plus-square
					span New Order
				.time-filter
					.btn-group
						button.btn.btn-primary(v-for="timeFilter_ in timeFilters" @click="setTimeFilterInner(timeFilter_)") {{timeFilter_.charAt(0).toUpperCase() + timeFilter_.slice(1)}}
					DatePicker(:updateFunction="setTimeFilter" :parentName="'orders-page'" :timeFilter="timeFilterInner" :style="{'padding-left': '10px'}")
		OrdersTable(v-if="Object.keys(orders).length" :orders="orders" :timeFilter="timeFilter" :activeStatus="activeStatus")
</template>

<script>
	import Screen 				from './../../mixins/screen';
	import {Order} 				from "@/services/Order";

	import OrdersTable 			from "@/components/Pages/OrdersTable";

	import DatePicker 			from "@/components/CustomControls/DatePicker";

	export default {
		name: 'OrderPage',
		mixins: [Screen],
		screen: {
			updateOn: ["Orders Loaded"],
			events: {

			},
		},
		props: ["activeStatus"],
		components: {
			OrdersTable,
			DatePicker
		},
		data() {

			this.Order = Order;
			this.orders = {};
			return {
				showed: true,
				timeFilters: ['today', 'yesterday', 'last 3 days', 'last 7 days', 'this month', 'last month'],
				timeFilter: 'last 3 days',
				timeFilterInner: 'last 3 days'
			}
		},
		methods: {
			collectData() {
				this.orders = Order.Orders;
				this.setTimeFilter(this.timeFilter);
			},
			showCreateNewOrder() {
				Broadcast.call("Show CreateNewOrder");
			},
			setTimeFilter(timeFilter) {
				this.timeFilter = timeFilter;
			},
			setTimeFilterInner(timeFilter) {
				this.timeFilterInner = timeFilter;
			}
		}
	}

</script>

<style lang="sass">

.orders-page
	display: flex
	flex-direction: column
	overflow: hidden
	flex: 1

	.orders-header
		display: flex
		flex-direction: column
		height: 60px
		background-color: #2a2b36
		justify-content: center

		.left-part
			display: flex
			flex-direction: row
			height: 40px
			padding-left: 15px

			.time-filter
				display: flex

				.btn-group > button
					color: black
					background-color: #66609d

					&:hover
						background-color: #8981C0

					&:focus
						box-shadow: unset
						background-color: #aba2e2
					&:active
						box-shadow: unset
						background-color: unset

				.btn-group > button:nth-child(1)
					border-top-left-radius: 15px
					border-bottom-left-radius: 15px
				.btn-group > button:nth-last-child(1)
					border-top-right-radius: 15px
					border-bottom-right-radius: 15px

			.new-order
				height: 100%
				color: #aaa1f5
				background-color: unset
				border: unset
				margin-right: 15px
				//border: unset
				//background: unset
				//padding: 0 30px 0 30px
				//border-radius: 5px

				>i
					padding-right: 5px

				&:hover
					background-color: #3a3b4a
					color: white
					border-radius: 10px
				&:focus
					box-shadow: unset

				&:active
					box-shadow: unset
					background-color: unset

</style>
